import { TOKEN_LOGIN, TOKEN_AUTOLOGOUT } from '../actions/token';

export const initialTokenState = {
  loggedIn: false,
  autoLogout: false,
  id: ''
};

const getState = function(state = initialTokenState, action) {
  switch (action.type) {
    case TOKEN_LOGIN:
      return {
        ...state,
        loggedIn: action.loggedIn,
        id: action.id
      };
    case TOKEN_AUTOLOGOUT:
      return {
        ...state,
        autoLogout: action.payload
      };
    default:
      return state;
  }
};
export default getState;
